import { IUser } from 'redux/store/user/types'
import { ProfileAbilityBuilder, UpdateAbilityContext } from '../types'
import { ACTIONS, ROLES, SUBJECTS } from 'features/Permission/constants'

export const defineVendorProfileAbilities = (
  builder: ProfileAbilityBuilder,
  role: string,
  user: IUser,
  profileId?: string
) => {
  const { can } = builder
  can(ACTIONS.EDIT, SUBJECTS.FORM_HOSPITAL_LIST)
  if (
    user.role === ROLES.VENDOR_CONTRACT_STEWARD &&
    (role === ROLES.COMMUNITY_PRESIDENT ||
      role === ROLES.VICE_PRESIDENT ||
      role === ROLES.CONTRACT_STEWARD ||
      role === ROLES.VENDOR_CONTRACT_ADMIN ||
      role === ROLES.VENDOR_CONTRACT_STEWARD ||
      role === ROLES.VENDOR_FINANCE_OFFICER)
  ) {
    can(ACTIONS.EDIT, SUBJECTS.FORM_ITEM)
  }
  if (
    user.uuid !== profileId &&
    (user.role === ROLES.VENDOR_FINANCE_OFFICER ||
      user.role === ROLES.VENDOR_ANALYST ||
      user.role === ROLES.VENDOR_LEGAL ||
      user.role === ROLES.SALES_REPRESENTATIVE)
  ) {
    can(ACTIONS.EDIT, SUBJECTS.FORM_ITEM)
  }
  if (user.role !== ROLES.VENDOR_FINANCE_OFFICER) {
    can(ACTIONS.ARCHIVE, SUBJECTS.USER)
  }
  if (role === ROLES.VENDOR_ANALYST || role === ROLES.SALES_REPRESENTATIVE) {
    can(ACTIONS.VIEW, SUBJECTS.COMPLIANCE)
  }
  if (role === ROLES.VENDOR_CONTRACT_STEWARD) {
    can(ACTIONS.VIEW, SUBJECTS.FORM_CONTARCT_CATEGORIES_INPUT)
  }

  if (
    user.role === ROLES.VENDOR_CONTRACT_STEWARD ||
    user.role === ROLES.VENDOR_LEGAL ||
    user.role === ROLES.VENDOR_ANALYST ||
    user.role === ROLES.SALES_REPRESENTATIVE
  ) {
    can(ACTIONS.VIEW, SUBJECTS.USER_CONTRACT_CATEGORIES_SETTINGS)
  }

  if (
    (user.role === ROLES.VENDOR_CONTRACT_ADMIN ||
      user.role === ROLES.VENDOR_CONTRACT_STEWARD) &&
    (role === ROLES.VENDOR_LEGAL ||
      role === ROLES.VENDOR_ANALYST ||
      role === ROLES.SALES_REPRESENTATIVE)
  ) {
    can(ACTIONS.VIEW, SUBJECTS.MY_COMMUNITY_USER_CONTRACT_CATEGORIES)
  }

  if (
    user.role === ROLES.VENDOR_CONTRACT_ADMIN &&
    role === ROLES.VENDOR_CONTRACT_STEWARD
  ) {
    can(ACTIONS.VIEW, SUBJECTS.MY_COMMUNITY_USER_CONTRACT_CATEGORIES)
  }
}

export const updateVendorAbilities = (
  builder: ProfileAbilityBuilder,
  ctx: UpdateAbilityContext
) => {
  const { can } = builder
  const { user, vendor } = ctx
  const isFullAccess = vendor?.vendor_permission === 'full_access'

  can(ACTIONS.VIEW, SUBJECTS.CHAT)
  can(ACTIONS.VIEW, SUBJECTS.CONTRACTS)
  if (user.role !== ROLES.VENDOR_FINANCE_OFFICER) {
    can(ACTIONS.VIEW, SUBJECTS.BIDDING)
  }
  if (
    user.role === ROLES.VENDOR_CONTRACT_STEWARD ||
    user.role === ROLES.VENDOR_FINANCE_OFFICER ||
    user.role === ROLES.VENDOR_CONTRACT_ADMIN
  ) {
    if (isFullAccess) {
      can(ACTIONS.VIEW, SUBJECTS.MARKET_INSIGHTS)
    }
  }
  if (user.role === ROLES.VENDOR_ANALYST) {
    can(ACTIONS.VIEW, SUBJECTS.PRODUCT_REQUESTS)
  }
  if (
    user.role == ROLES.VENDOR_CONTRACT_STEWARD ||
    user.role === ROLES.VENDOR_CONTRACT_ADMIN
  ) {
    can(ACTIONS.EDIT, SUBJECTS.USER)
  }

  if (user.role === ROLES.SALES_REPRESENTATIVE) {
    can(ACTIONS.VIEW, SUBJECTS.VENDOR_USERS)
  }

  if (user.role === ROLES.VENDOR_CONTRACT_ADMIN) {
    can(ACTIONS.CRUD, SUBJECTS.VENDOR_USERS)
    can(ACTIONS.VIEW, SUBJECTS.PRODUCT_REQUESTS)
    can(ACTIONS.CRUD, SUBJECTS.VENDOR)
  }

  if (user.role === ROLES.VENDOR_CONTRACT_STEWARD) {
    can(ACTIONS.VIEW, SUBJECTS.PRODUCT_REQUESTS)
  }

  if (user.role === ROLES.VENDOR_CONTRACT_STEWARD && isFullAccess) {
    can(ACTIONS.CRUD, SUBJECTS.VENDOR_USERS)
  }
  if (user.role !== ROLES.VENDOR_CONTRACT_ADMIN) {
    can(ACTIONS.VIEW, SUBJECTS.VENDOR_CONTRACT_ADMIN)
  }
  if (
    user.role !== ROLES.SALES_REPRESENTATIVE &&
    user.role !== ROLES.VENDOR_LEGAL &&
    isFullAccess
  ) {
    can(ACTIONS.VIEW, SUBJECTS.FINANCIALS)
  }
  if (user.role === ROLES.VENDOR_CONTRACT_STEWARD && isFullAccess) {
    can(ACTIONS.VIEW, SUBJECTS.BIDDING)
  } else if (user.role !== ROLES.VENDOR_FINANCE_OFFICER) {
    if (isFullAccess) {
      can(ACTIONS.VIEW, SUBJECTS.BIDDING)
    }
  }
  if (user.role === ROLES.VENDOR_CONTRACT_STEWARD) {
    if (isFullAccess) {
      can(ACTIONS.VIEW, SUBJECTS.CONTRACTS)
    }
  } else {
    if (isFullAccess) {
      can(ACTIONS.VIEW, SUBJECTS.CONTRACTS)
    }
  }
  if (isFullAccess) {
    can(ACTIONS.VIEW, SUBJECTS.CALENDAR)
    can(ACTIONS.VIEW, SUBJECTS.MY_COMMUNITY)
  }

  if (
    user.role === ROLES.VENDOR_CONTRACT_ADMIN ||
    user.role === ROLES.VENDOR_CONTRACT_STEWARD ||
    user.role === ROLES.VENDOR_ANALYST ||
    user.role === ROLES.VENDOR_LEGAL
  ) {
    can(ACTIONS.VIEW, SUBJECTS.PRODUCT_REQUESTS)
  }
}
